<template>
  <ItOpsBrowserLab v-if="kind === 'browser'" />
  <ItOpsKnowledgeLab v-else />
</template>

<script>
import ItOpsBrowserLab from './ItOpsBrowserLab.vue';
import ItOpsKnowledgeLab from './ItOpsKnowledgeLab.vue';
export default {
  name: 'ItOpsJourney',
  components: { ItOpsBrowserLab, ItOpsKnowledgeLab },
  props: { kind: { type: String, default: 'knowledge' } },
};
</script>
